import { type RecoveryFormValues } from "./type";

export const titleTestId = "pages/signin/__components__/recovery-forms/title";

export const descriptionTestId = "pages/signin/__components__/recovery-forms/description";

export const submitButtonTestId = "pages/signin/__components__/recovery-forms/confirm-screen/submit";

export const changeMfaCodeScreenTestId =
  "pages/signin/__components__/recovery-forms/confirm-screen/change-mfa-code-screen";

export const defaultValuesRecoveryForm: RecoveryFormValues = {
  recoveryCode: "",
};
